export default __webpack_public_path__ + "static/more_info_aib-4f25eaad40cd1ec07a6abffb113afa22.pdf";